export default "/images/3d1faf7352aa006ded22cbce38a4f59c.avif";